/* Trace-id generation.

   The backend logs every request against the `X-Trace-Id` the client sends, so
   a support ticket becomes a single log search. The format matches W3C
   trace-context's trace-id: 32 lowercase hex characters. */

const HEX = '0123456789abcdef'

function randomHex(length: number): string {
  const bytes = new Uint8Array(length / 2)
  crypto.getRandomValues(bytes)
  let out = ''
  for (const byte of bytes) {
    out += HEX[byte >> 4]! + HEX[byte & 0x0f]!
  }
  return out
}

export function newTraceId(): string {
  // crypto.randomUUID is available everywhere we target, but stripping its
  // dashes is the same 32 hex chars and avoids a second code path.
  if (typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID().replace(/-/g, '')
  }
  return randomHex(32)
}

/* Idempotency keys for submit and import-confirm. The SAME key is reused
   across every retry of one logical action — that is the whole point. */
export function newIdempotencyKey(): string {
  return newTraceId()
}

/* The trace id of the most recent request, so an error boundary can report the
   context a crash happened in even when it has no error object of its own. */
let lastTraceId: string | null = null

export function rememberTraceId(traceId: string): void {
  lastTraceId = traceId
}

export function getLastTraceId(): string | null {
  return lastTraceId
}
